export const maxTextAreaLength = 5000;
export const textAreaDefaultLength = 500;
export const inputDefaultLength = 235;
export const telephoneNumberDefaultLength = 12;
